import React from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../services/ApiService';

export const ResetPasswordPage: React.FC = () => {
  const [email, setEmail] = React.useState('');
  const [sent, setSent] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await apiService.sendPasswordResetEmail(email);
      setSent(true);
    } catch (err: any) {
      setError(err.message || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-xl shadow-sm p-6">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-normal text-gray-900 mb-2">Reset your password</h1>
          <p className="text-gray-600 text-sm">Enter your email to receive a password reset link.</p>
        </div>
        {sent ? (
          <div className="text-center text-green-600">Check your email for a reset link.</div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="email" className="text-sm font-normal text-gray-700">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                className="w-full h-11 border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-900"
                placeholder="Enter your email"
              />
            </div>
            {error && <div className="text-red-600 text-sm">{error}</div>}
            <button
              type="submit"
              disabled={loading || !email}
              className="w-full h-11 bg-gray-900 hover:bg-gray-800 text-white rounded-md text-sm font-normal disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="w-full h-11 mt-2 border border-gray-200 rounded-md text-sm text-gray-700 hover:bg-gray-50"
            >
              Back to login
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
